<div class="progress-cont">
  <div [className]="'progress ' + ((status === 'DONE') ? ' done ' : (status === 'FAILED') ? ' failed ' : '')" [style.width]="progress + '%'">
  </div>
</div>
